import React from 'react';

import { Badge, Button, Modal, Form } from 'react-bootstrap';
import { useMount } from 'ahooks';
import { useDispatch, useSelector } from 'react-redux';

// Roba del tema
import HtmlHead from 'components/html-head/HtmlHead';
import Loading from 'components/loading/Loading';

import { resetStato, apriModaleRisposta, chiudiModaleRisposta, setMessaggioDaInviare } from 'features/99/conversazioni/conversazioniSlice';
import { richiediDati, rispondi } from './funzioni';

const TicketPadre = ({ ticket, onRispondi }) => {
  return (
    <div className="card card border border-primary">
      <div className="card-body d-flex justify-content-between align-items-center">
        <div>
          <h4 className="card-title">{ticket.Testo}</h4>

          <Badge bg={ticket.Stato.toLowerCase() === 'chiuso' || ticket.Stato.toLowerCase() === 'closed' ? 'danger' : 'success'}>{ticket.Stato}</Badge>
        </div>
        {ticket.Stato === 'Aperto' && (
          <div className="ms-2">
            <Button variant="primary" disabled={ticket.Stato.toLowerCase === 'chiuso' || ticket.Stato.toLowerCase === 'closed'} onClick={onRispondi}>
              Reply
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

const Messaggio = ({ messaggio }) => {
  const Destro = ({ testo, data }) => {
    return (
      <div className="d-flex w-100 align-items-end justify-content-end mb-3">
        <div className="d-flex flex-column">
          <span className="text-small text-alternate opacity-75 time text-end m-2">{data}</span>
          <div className="bg-primary mw-md-75 rounded-md p-3 d-inline-flex align-items-center justify-content-end">
            <p className="m-0 text text-white">{testo}</p>
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center text-white rounded-circle bg-secondary ms-2" style={{ width: 50, height: 50 }}>
          You
        </div>
      </div>
    );
  };

  const Sinistro = ({ testo, data }) => {
    return (
      <div className="d-flex w-100 align-items-end justify-content-start mb-3">
        <div className="d-flex justify-content-center align-items-center p-2 rounded-circle bg-dark me-2" style={{ width: 50, height: 50 }}>
          <svg viewBox="0 0 116 116" fill="none">
            <path
              d="M29.9299 90.26V88.54C31.6162 88.2897 33.1915 87.549 34.4599 86.41C36.2252 84.387 37.553 82.0208 38.3599 79.46L57.9999 26H59.5399L80.6899 80.16C81.2964 81.9214 82.0594 83.6248 82.9699 85.25C83.6355 86.19 84.5123 86.9606 85.5299 87.5C86.8107 88.0991 88.1973 88.439 89.6099 88.5V90.22H66.6099V88.54C69.2099 88.27 70.8999 87.77 71.6699 87.06C72.0516 86.7173 72.354 86.2955 72.556 85.824C72.7581 85.3526 72.855 84.8427 72.8399 84.33C72.8399 82.7767 72.2033 80.3667 70.9299 77.1L56.5499 40.27L43.2599 76.62C41.9599 80.2 41.3099 82.6867 41.3099 84.08C41.33 84.5665 41.4464 85.0441 41.6524 85.4853C41.8584 85.9264 42.1498 86.3223 42.5099 86.65C43.6607 87.6262 45.0791 88.2327 46.5799 88.39L47.2899 88.52V90.24L29.9299 90.26Z"
              fill="white"
            />
            <path
              d="M95.83 62.42C92.6663 64.7412 89.0891 66.4382 85.29 67.42C80.8067 68.553 76.1937 69.091 71.57 69.02C66.1602 68.9582 60.7596 68.5575 55.4 67.82C49.04 67.02 44.9233 66.62 43.05 66.62C37.05 66.62 32.3233 67.8734 28.87 70.38C27.215 71.4915 25.8671 73.0025 24.9512 74.7732C24.0352 76.5439 23.5808 78.5171 23.63 80.51C23.6504 82.3914 24.0306 84.2515 24.75 85.99C25.1928 86.9867 25.567 88.0124 25.87 89.06C25.8853 89.1609 25.8771 89.264 25.8458 89.3612C25.8146 89.4584 25.7613 89.547 25.69 89.62C25.502 89.757 25.2722 89.8242 25.04 89.81C24.37 89.81 23.53 88.7 22.52 86.49C21.5416 84.426 21.023 82.1741 21 79.89C21 74.6034 23.5133 70.27 28.54 66.89C33.5667 63.51 39.98 61.8067 47.78 61.78C52.438 61.9362 57.0827 62.367 61.69 63.07C66.8877 63.8714 72.1322 64.3324 77.39 64.45C80.0935 64.4316 82.794 64.268 85.48 63.96C88.5133 63.6267 91.98 63.1134 95.88 62.42"
              fill="white"
            />
          </svg>
        </div>
        <div className="d-flex flex-column">
          <span className="text-small text-alternate opacity-75 time m-2">{data}</span>
          <div className="bg-dark mw-md-75 rounded-md p-3 d-inline-flex align-items-center justify-content-end">
            <p className="m-0 text">{testo}</p>
          </div>
        </div>
      </div>
    );
  };

  if (messaggio.Operatore === null) {
    return <Destro testo={messaggio.Testo} data={messaggio.DataOra} />;
  }

  return <Sinistro testo={messaggio.Testo} data={messaggio.DataOra} />;
};

const Conversazione99 = ({ match, history }) => {
  const dispatch = useDispatch();

  // check if id is present in the URL and check if it is a number or redirect
  if (!match.params.id || Number.isNaN(parseInt(match.params.id, 10))) {
    return history.push('/99/ticket');
  }

  // get state
  const { caricamentoInCorso, messaggi, padre, mostraModaleRisposta, messaggioDaInviare } = useSelector((state) => state.conversazioni99);

  // Richiedi dati
  const { id } = match.params;
  useMount(() => {
    dispatch(resetStato());
    richiediDati(id);
  });

  if (caricamentoInCorso) {
    return (
      <>
        <HtmlHead title="Conversazione" />
        <Loading />
      </>
    );
  }

  return (
    <>
      <HtmlHead title="Conversazione" />

      <h1>Conversation </h1>

      <section className="scroll-section my-5">
        <TicketPadre ticket={padre} onRispondi={() => dispatch(apriModaleRisposta())} />
      </section>

      <section className="scroll-section">
        <div className="card">
          <div className="card-body">
            {messaggi.map((messaggio) => (
              <Messaggio key={messaggio.Id_Ticket} messaggio={messaggio} />
            ))}
          </div>
        </div>
      </section>

      <Modal show={mostraModaleRisposta} onHide={() => dispatch(chiudiModaleRisposta())}>
        <Modal.Header closeButton>
          <Modal.Title>Reply</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formMessaggio.InputMessaggio">
              <Form.Label>Enter your message for Alfrus here</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                maxLength={500}
                required
                value={messaggioDaInviare}
                onChange={(v) => dispatch(setMessaggioDaInviare(v.target.value))}
              />
              <Form.Control.Feedback type="invalid">Please enter a message of up to 500 characters</Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => dispatch(chiudiModaleRisposta())}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => rispondi(id)}>
            Send Message
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Conversazione99;
